import { render, staticRenderFns } from "./AtomStickyContact.vue?vue&type=template&id=02bef44e&"
import script from "./AtomStickyContact.vue?vue&type=script&lang=js&"
export * from "./AtomStickyContact.vue?vue&type=script&lang=js&"
import style0 from "./AtomStickyContact.vue?vue&type=style&index=0&id=02bef44e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonAtomIcon: require('/app/components/atoms/common/AtomIcon.vue').default,AtomsCommonAtomButton: require('/app/components/atoms/common/AtomButton.vue').default})
